<template>
  <div class="flex-row justify-content-between" data-dusk="notes-filter-component">
    <div class="flex-row gap-sm align-items-center">
      <dd-filter-pill v-if="filter.title"
                      @click="deleteFilter('title')"
                      title="Filter actief: Onderwerp"
                      data-dusk="note-title"
      >
        Onderwerp
      </dd-filter-pill>
      <dd-filter-pill v-if="filter.dateRange && filter.dateRange.length"
                      @click="deleteFilter('dateRange')"
                      title="Filter actief: Periode"
                      data-dusk="date-range"
      >
        Periode
      </dd-filter-pill>
      <dd-filter-pill v-if="filter.createdByUser && filter.createdByUser.length"
                      @click="deleteFilter('createdByUser')"
                      title="Filter actief: Gebruiker(s)"
                      data-dusk="created-by-user"
      >
        Gebruiker(s)
      </dd-filter-pill>
      <dd-filter-pill v-if="filter.visibleForCustomer"
                      @click="deleteFilter('visibleForCustomer')"
                      title="Filter actief: Zichtbaar voor klant"
                      data-dusk="visible-for-customer"
      >
        Zichtbaar voor klant
      </dd-filter-pill>
    </div>

    <a-dropdown v-model="showFilter" :trigger="['click']" >
      <dd-filter-button
          :filter-count="filterCount"
          data-dusk="filter-button"
      ></dd-filter-button>
      <template #overlay>
        <notes-filter-dropdown
            @close="showFilter = false"
            :value="filter"
            @input="(newFilter) => onNewFilter(newFilter)"
            v-model="filter"
        />
      </template>
    </a-dropdown>
  </div>
</template>

<script>
import NotesFilterDropdown from './NotesFilterDropdown.vue';
import Vue from 'vue';
import keyValueStoreApi from '~/api/key_value_store';
export default {
  name: "NotesFilter",
  components: {
    NotesFilterDropdown,
  },
  emits: ['input'],
  created() {
    this.setCachedFilter();
  },
  data() {
    return {
      showFilter: false,
      filter: { },
    }
  },
  computed: {
    filterCount() {
      let count = 0;
      if (Object.entries(this.filter)) {
        for (const [key, value] of Object.entries(this.filter)) {
          if (value === undefined) continue;
          if ((value !== null) && value.length) {
            count++
          }
        }
      }
      return count || undefined;
    },
    hasFilter() {
      return Object.entries(this.filter)
          && Object.entries(this.filter).some(([key, value]) => value !== null && value !== undefined);
    },
  },
  methods: {
    deleteFilter(key) {
      Vue.delete(this.filter, key);
      this.emitFilter();
    },
    emitFilter() {
      this.$emit('input', this.filter);
      this.saveFilterToKeyValueStore();
    },
    onNewFilter() {
      this.emitFilter();
    },
    saveFilterToKeyValueStore() {
      if (this.hasFilter === false) {
        keyValueStoreApi.forget('notes_drawer_filter');
      } else {
        keyValueStoreApi.set('notes_drawer_filter', this.filter);
      }
    },
    async setCachedFilter() {
      const hasCachedFilter = await keyValueStoreApi.has('notes_drawer_filter');
      // Emit empty filter to notify parent element notes can be retrieved.
      if (!hasCachedFilter) return this.emitFilter();
      const cachedFilter = await keyValueStoreApi.get('notes_drawer_filter');
      this.filter = {
        title: cachedFilter.title,
        dateRange: cachedFilter.dateRange,
        visibleForCustomer: cachedFilter.visibleForCustomer,
        createdByUser: cachedFilter.createdByUser,
      };
      this.emitFilter();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
